export default __webpack_public_path__ + "static/media/loooool-77.a81c203f.png";